import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import ColorWrapper from '@styles/colors';
import BaseFrame from './baseFrame';

import { updateCompanyProfileValue } from '@reducers/membership';

import { languages } from '@helpers';
import { FeatureFlagsAvailable } from '@components/featureFlags';
import { updateLabelSwitchedOn } from '@reducers/language';
import { LABEL_PATTERN, LANGUAGE_LABELS_FEATURE_FLAG } from '@v2/pages/common/constants/base.constants';

const BaseModal = (props) => {
  const {
    user,
    user: { featureFlags },
    updateCompanyProfileValue,
    updateLabelSwitchedOn,
    labelSwitchedOn,
  } = props;

  const data = languages.filter((i) => (i.flag ? FeatureFlagsAvailable(i.flag, featureFlags) : true));

  const [submitLoading, setSubmitLoading] = useState(false);
  const [selected, setSelected] = useState(user?.userInfo?.companyProfile?.language);

  const onSelect = (item) => {
    setSelected(item.value);
  };

  const onCancel = () => {};

  const onSubmit = async () => {
    setSubmitLoading(true);
    await updateCompanyProfileValue({ language: selected });
    setSubmitLoading(false);
  };

  const filteredLanguages = labelSwitchedOn
    ? data.filter((l) => l.value.startsWith(LABEL_PATTERN))
    : data.filter((l) => !l.value.startsWith(LABEL_PATTERN));

  const isLanguageLabelsAvailable = FeatureFlagsAvailable(LANGUAGE_LABELS_FEATURE_FLAG, featureFlags);

  return (
    <BaseFrame
      {...{
        submitLoading,
        data: filteredLanguages,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Language',
        selected,
        ...(isLanguageLabelsAvailable
          ? {
              footerBlockConfig: {
                title: 'Display Label Numbers',
                description:
                  'Display language label numbers to assist with translation. This setting will automatically reset after restarting the app or logging in again.',
                action: updateLabelSwitchedOn,
                height: 55,
                value: labelSwitchedOn,
              },
            }
          : {}),
        ...props,
      }}
    />
  );
};

export default connect(({ user, language: { labelSwitchedOn } }) => ({ user, labelSwitchedOn }), {
  updateCompanyProfileValue,
  updateLabelSwitchedOn,
})(ColorWrapper(BaseModal));
